// src/components/layout/Footer.jsx
// Footer component with contact information

import React from 'react';
import { APP_CONFIG } from '../../config/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 w-full px-6 py-12 bg-white/50 backdrop-blur-sm border-t-4 border-gray-200 dark:bg-gray-900/70 dark:border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/coasthive-logo.png" alt="Coasthive" className="w-10 h-10 object-contain rounded-2xl no-invert" />
              <span className="text-2xl font-bold gradient-text">{APP_CONFIG.companyName}</span>
            </div>
            <p className="text-gray-600 mb-4">{APP_CONFIG.tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-gray-600 hover:text-pink-600 transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-600 hover:text-pink-600 transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-600 hover:text-pink-600 transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-gray-600">
                <span>📧</span>
                <a
                  href={`mailto:${APP_CONFIG.contactEmail}`}
                  className="hover:text-pink-600 transition-colors"
                >
                  {APP_CONFIG.contactEmail}
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-600">
                <span>💬</span>
                <a
                  href={`mailto:${APP_CONFIG.supportEmail}`}
                  className="hover:text-pink-600 transition-colors"
                >
                  {APP_CONFIG.supportEmail}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} {APP_CONFIG.companyName}. All rights reserved. Made with ❤️ and lots of ☕
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
